import React, { useState, useEffect } from 'react';
import BaseForm from '../../app/components/BaseForm';
import Input from '../../app/components/Input';
import Select from '../../app/components/Select';

const FormEditTaxObligation = ({ isOpen, onClose, title, selectObligation, onSubmit }) => {
  const [formData, setFormData] = useState({
    nome: '',
    departamento: '',
    responsavel: '',
    passivelMulta: '',
  });

  useEffect(() => {
    if (selectObligation) {
      setFormData({
        id: selectObligation.id || null,
        nome: selectObligation.nome || '',
        departamento: selectObligation.departamento || '',
        responsavel: selectObligation.responsavel || '',
        passivelMulta: selectObligation.passivelMulta || 'Não',
      });
    } else {
      setFormData({
        nome: '',
        departamento: '',
        responsavel: '',
        passivelMulta: 'Não',
      });
    }
  }, [selectObligation]);

  const handleChange = (eOrValue, fieldName) => {
    if (typeof eOrValue === 'object' && eOrValue !== null && 'value' in eOrValue) {
      setFormData(prev => ({
        ...prev,
        [fieldName]: eOrValue.value,
      }));
    } else {
      const { name, value } = eOrValue.target;
      setFormData(prev => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const departamentoOptions = [
    { value: 'Fiscal', label: 'Fiscal' },
    { value: 'Contábil', label: 'Contábil' },
    { value: 'Recursos Humanos', label: 'Recursos Humanos' },
    { value: 'Financeiro', label: 'Financeiro' },
    { value: 'Administrativo', label: 'Administrativo' },
  ];

  const passivelMultaOptions = [
    { value: 'Sim', label: 'Sim' },
    { value: 'Não', label: 'Não' },
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit && typeof onSubmit === 'function') {
      onSubmit(formData);
    }
  };

  const renderFormField = () => {
    return (
      <div>
        <div className='pb-4'>
          <Input
            className="mt-2"
            label='Nome da obrigação'
            name='nome'
            placeholder="Digite o nome da obrigação fiscal..."
            value={formData.nome}
            onChange={handleChange}
            required
          />
        </div>
        
        <div className='pb-4'>
          <Select
            label='Departamento'
            placeholder="Selecione o departamento"
            name='departamento'
            options={departamentoOptions}
            value={formData.departamento}
            onChange={(option) => handleChange(option, 'departamento')}
            className="mt-2"
          />
        </div>
        
        <div className='pb-4'>
          <Input
            className="mt-2"
            label='Responsável'
            name='responsavel'
            placeholder="Digite o nome do responsável..."
            value={formData.responsavel}
            onChange={handleChange}
            required
          />
        </div>
        
        <div className='pb-4'>
          <Select
            label='Passível de multa?'
            placeholder="Selecione uma opção"
            name='passivelMulta'
            options={passivelMultaOptions}
            value={formData.passivelMulta}
            onChange={(option) => handleChange(option, 'passivelMulta')}
            className="mt-2"
          />
        </div>

      </div>
    );
  };

  return (
    <BaseForm
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
      title={title}
      className='max-w-4xl'
    >
      {renderFormField()}
    </BaseForm>
  );
};

export default FormEditTaxObligation;